  <div class="control-section" *ngIf="chartData && chartComplete; else loadingValidationChart">
    <ejs-chart id="chart-container-ingested" [chartArea]="chartArea" [primaryXAxis]='primaryXAxis'
      [primaryYAxis]='primaryYAxis' [title]='chartTitle' [legendSettings]="legendSettings" [titleStyle]='titleStyle'
      [tooltip]='tooltip' (textRender)="onTextRender($event)" [enableAnimation]='enableAnimation'
      [subTitleStyle]="subtitleStyle" [subTitle]="subTitle" selectionMode="Series" background='#fff'
      enableComplexProperty=true (load)="load($event)" (seriesRender)="seriesRender($event)">
      <e-series-collection>
        <e-series [dataSource]='chartData' type='Column' xName='channel' yName='pass' name='Pass' columnWidth=0.96
          fill="#29A829" [marker]='marker' legendShape='Rectangle' [cornerRadius]='radius'></e-series>
        <e-series [dataSource]='chartData' type='Column' xName='channel' yName='fail' name='Fail' columnWidth=1
          fill="#FF3131" [marker]='marker' legendShape='Rectangle' [cornerRadius]='radius'></e-series>
      </e-series-collection>
    </ejs-chart>
  </div>

<ng-template #loadingValidationChart>
  <div class="col-sm-12 chart-spinner-div">
    <div class="col-sm-10 center-block loading-chart-message">
      Loading chart<br>Device Validations by Health Authority
      <span class="loading-dots loading-dots-font">
        <span>.</span><span>.</span><span>.</span>
      </span>
    </div>
    <div id="loadingCharts"></div>
  </div>
</ng-template>


